import React, {
  lazy,
} from 'react';
import {
  Navigate,
  RouteObject,
} from 'react-router-dom';
import LazyLoadComponent from 'core/components/LazyLoadComponent';
import FullScreenSpinner from 'core/components/FullScreenSpinner';
import useEMRAccess from 'views/EMR/hooks/useEMRAccess';
import SETTINGS_PATHS from 'views/EMR/Settings/paths';

function SettingsRouteRedirect() {
  const {
    defaultSettingsPath,
    userInfo,
  } = useEMRAccess();

  return userInfo === null
    ? <FullScreenSpinner />
    : <Navigate to={defaultSettingsPath} replace />;
}

const settingsRoutes: RouteObject[] = [{
  path: SETTINGS_PATHS.ROOT,
  element: <SettingsRouteRedirect />,
}, {
  path: SETTINGS_PATHS.USERS,
  element: (
    <LazyLoadComponent Component={lazy(() => import('./Users'))} />
  ),
}, {
  path: `${SETTINGS_PATHS.APPOINTMENTS}/:config`,
  element: (
    <LazyLoadComponent Component={lazy(() => import('./Appointments'))} />
  ),
}, {
  path: SETTINGS_PATHS.APPOINTMENTS,
  element: <Navigate to={`${SETTINGS_PATHS.APPOINTMENTS}/types`} replace />,
}, {
  path: `${SETTINGS_PATHS.VISIT_NOTES}/:config`,
  element: (
    <LazyLoadComponent Component={lazy(() => import('./VisitNotes'))} />
  ),
}, {
  path: `${SETTINGS_PATHS.PAYERS}/:type`,
  element: (
    <LazyLoadComponent Component={lazy(() => import('./Payers'))} />
  ),
}, {
  path: SETTINGS_PATHS.VISIT_NOTES,
  element: <Navigate to={`${SETTINGS_PATHS.VISIT_NOTES}/master-templates`} replace />,
}, {
  path: SETTINGS_PATHS.PAYERS,
  element: <Navigate to={`${SETTINGS_PATHS.PAYERS}/electronic`} replace />,
}, {
  path: SETTINGS_PATHS.FORMS,
  element: (
    <LazyLoadComponent Component={lazy(() => import('./Forms'))} />
  ),
}, {
  path: SETTINGS_PATHS.TAGS,
  element: (
    <LazyLoadComponent Component={lazy(() => import('./Tags'))} />
  ),
}, {
  path: SETTINGS_PATHS.ORGANIZATION,
  element: (
    <LazyLoadComponent Component={lazy(() => import('./BillingConfigurations'))} />
  ),
}, {
  path: SETTINGS_PATHS.PCC,
  element: (
    <LazyLoadComponent Component={lazy(() => import('./PCC'))} />
  ),
}];

export default settingsRoutes;
